import { create } from "zustand";
import api from "../api/api";

type Profile = {
    name: string
    email: string
    ic_number: string
    birthday: string
    profile_pic: string | null
    phone: string,
}

interface ProfileStore {
    profile: Profile | null
    fetchProfile: () => Promise<void>
}

export const useProfileStore = create<ProfileStore>((set) => ({
    profile: null,
    fetchProfile: async () => {
        try {
            const res = await api.get(`${process.env.REACT_APP_API_BASE_URL}/user/profile`);
            set({ profile: res.data.data })
        } catch (err) {
            console.error("Failed to fetch profile:", err);
        }
    },
}))